import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../../../../api/ajax-endpoints";
import { getData } from "../../../../../../../newApis/dotNetApiMethods";
import { IPaginatedResponse } from "../../../../../../../interfaces/response";

export type TUserData = {
  id: number;
  bvn: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  initiatedBy: null;
  currentApprovedAmount: number | null;
  batchReferenceNumber: string | null;
  requestedApprovedAmount: number | null;
  currentRoles: string[];
  rolesRequestedForApproval: string[] | null;
  customerUserApproverDetails: any | null;
  status: string;
  createdAt: string;
  updatedAt: string | null;
  ssoUserId: string;
  userId: number;
};

type paramProps = {
  funder_id: number;
  pageSize?: number;
  page?: number;
};

const getTeamMembers = async ({ funder_id, pageSize, page }: paramProps) => {
  const params = new URLSearchParams();
  params.set("CustomerId", String(funder_id));
  if (page !== undefined && page !== null) params.set("Page", String(page));
  if (pageSize !== undefined && pageSize !== null)
    params.set("PageSize", String(pageSize));

  const url = `${ajaxEndpoints.GET_USER_APPROVALS}?${params.toString()}`;

  const response = await getData(url);
  return response.data;
};

export default function useTeamMembers({
  funder_id,
  page,
  pageSize,
}: paramProps) {
  return useQuery<IPaginatedResponse<TUserData[]>>(
    [{ funder_id, pageSize, page }, "getTeamMembers"],
    getTeamMembers,
    {
      refetchOnWindowFocus: false,
    },
  );
}
